import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-forum-question',
  templateUrl: './forum-question.component.html',
  styleUrls: ['./forum-question.component.scss']
})
export class ForumQuestionComponent {
  forumQuestion: any = '';
  editor: any = ClassicEditor;
  question: any = '';
  constructor(private appService: AppService, public dialogRef: MatDialogRef<ForumQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    setTimeout(() => {
      document.querySelectorAll('.ck.ck-toolbar .ck-dropdown')[2]['style']['display'] = 'none';
    }, 1000);
  }

  ngOnViewInit() {

  }

  formatDateForPostgres(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  save() {
    // console.log(new Date().toISOString().substring(0, 10) )
    let body = {
      "title": this.question,
      "description": this.forumQuestion,
      "user_id": sessionStorage.getItem('loginId'),
      "forum_date": this.formatDateForPostgres(new Date().toISOString()),
      "status": "Active",
      "createdBy": sessionStorage.getItem('loginId'),
      "createdAt": this.formatDateForPostgres(new Date().toISOString()),
      "updatedBy": sessionStorage.getItem('loginId'),
      "updatedAt": this.formatDateForPostgres(new Date().toISOString())
    }
    // console.log(body)
    this.appService.saveQuestionDetails(body).subscribe((res: any) => {
      this.dialogRef.close('success');
    });
    // console.log(body)
  }
}
